import React from 'react';
import css from './ItemsTypesTable.module.css';
import { ItemTypeEntity } from '@entities/ItemType/Types';
import { ItemsTypesTableRow } from '@modules/Steps/Components/Step2/Step2DesktopContent/FragmentInfoStep2/ItemsTypesTable/ItemsTypesTableRow/ItemsTypesTableRow';
import {
    BasicTableHeader,
    HeaderCell,
} from '@modules/Steps/Shared/Ui/Headers/BasicTableHeader/BasicTableHeader';
import { HasItems } from '@modules/Steps/Shared/Helpers/HasItems';
import { useProjectStore } from '../../../../../../../Stores/ProjectStore';
import { CustomProjectStep2ElementsIdsEnum } from '@modules/Steps/Shared/Enums/CustomProjectStep2ElementsIdsEnum';
import { useFragmentsStore } from '../../../../../../../Stores/FragmentsStore';

interface Props {
    itemTypes: ItemTypeEntity[];
}

const headerCells: HeaderCell[] = [
    { title: 'Product', width: '21.80%' },
    { title: 'Calculated QTY', width: '33.86%' },
    { title: 'Unit price', width: '30.65%' },
    { title: 'Total', width: '10.29%' },
];

export const ItemsTypesTable: React.FC<Props> = ({ itemTypes }) => {
    const filteredItemTypes = itemTypes.filter(itemType => itemType.qty > 0);
    const { itemTypesWithItems } = useFragmentsStore();

    let firstItemTypeWithItemsIndex = -1;
    filteredItemTypes.forEach((itemType, index) => {
        if (
            firstItemTypeWithItemsIndex === -1 &&
            HasItems(itemType.id, itemTypesWithItems)
        ) {
            firstItemTypeWithItemsIndex = index;
        }
    });

    return (
        <div className={css.tableContainer}>
            <BasicTableHeader headerCells={headerCells} />
            <div className={css.table}>
                {filteredItemTypes.map((itemType, index) => (
                    <div
                        id={
                            index === firstItemTypeWithItemsIndex
                                ? CustomProjectStep2ElementsIdsEnum.WORK_AREA_STEP2_SELECT_PRODUCT
                                : undefined
                        }
                        key={itemType.uuid}
                    >
                        <ItemsTypesTableRow
                            itemType={itemType}
                            key={itemType.uuid}
                        />
                    </div>
                ))}

                <div className={css.emptyRow}></div>
            </div>
        </div>
    );
};
